export function filterBlock() {
    const filterBlock = $(".filter-block");
    const checkers = filterBlock.find("input[type=\"checkbox\"]");

    checkers.on("change", function () {
        const $this = $(this);
        if($this.hasClass("check-all")) {
            if(!$this.prop("checked")) {
                $this.siblings("input[type=\"checkbox\"]").prop("checked", false);
            } else {
                $this.siblings("input[type=\"checkbox\"]").prop("checked", true);
            }
        } else {
            $this.parents(".filter-block").find(".check-all").prop("checked", false);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/filter-block.js